function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffd100",
      fillOpacity: 1
    },
    d: "M181.754 56.043c0 4.39-4.082 7.945-9.113 7.945-5.032 0-9.114-3.554-9.114-7.945 0-4.387 4.082-7.945 9.114-7.945 5.03 0 9.113 3.558 9.113 7.945Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#061ab1",
      fillOpacity: 1
    },
    d: "M44.816 38.39v10.395h9.918c-1.453 1.985-4.714 3.031-6.933 3.031-7.461 0-11.192-3.718-11.192-11.199 0-8.27 4.93-12.5 14.707-12.5 3.891 0 8.957.84 14.414 2.344V18.03c-1.57-.582-3.964-1.047-7.007-1.488-3.145-.465-5.895-.652-8.29-.652-9.699 0-17.398 2.277-23.152 6.832-5.754 4.554-8.66 10.683-8.66 18.425 0 7.086 2.238 12.688 6.715 16.797 4.477 4.16 10.527 6.25 18.144 6.25 7.641 0 14.672-3.46 16.95-7.86l-.04 7.071h11.055V38.391ZM76.887 63.426V16.68H94.07v34.57h18.735v12.176ZM118.262 62.242V49.484c2.535.723 5.52 1.305 8.879 1.817 3.355.515 6.261.789 8.738.789 4.184 0 6.344-.91 6.344-2.535 0-1.043-.668-1.559-3.73-2.14l-5.973-1.165c-10.23-2.02-15.004-6.508-15.004-14.125 0-5.02 2.023-8.992 5.972-11.918 3.965-2.86 9.485-4.3 16.418-4.3 4.77 0 12.094.84 16.574 1.816v12.175a97.606 97.606 0 0 0-8.445-1.492c-3.36-.46-5.969-.648-7.914-.648-3.652 0-5.754.906-5.754 2.535 0 .973.961 1.625 2.985 2.086l6.953 1.441c10.152 2.086 14.863 6.64 14.863 14.383 0 4.95-2.082 8.852-6.203 11.711-4.106 2.86-9.781 4.297-17.028 4.297-6.855-.016-13.804-.856-17.675-1.969Zm0 0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGls);
export default __webpack_public_path__ + "static/media/gls.3e07ea5c26684bbd3863902964fb82c3.svg";
export { ForwardRef as ReactComponent };